import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { CustomWindowService } from 'app/core/services/custom-window-service/custom-window.service';
import * as DossierActions from 'app/modules/dossier-area/pages/dossier/store/dossier.actions';
import * as SachverhaltActions from 'app/modules/shared-area/entry-components/sachverhalt/store/sachverhalt.actions';
import * as WindowActions from './window.actions';

@Injectable()
export class WindowEffects {
  closeWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        WindowActions.closeWindow,
        SachverhaltActions.createSachverhaltAndCloseSuccess,
        DossierActions.loadSubstanceSuccess.type,
      ),
      tap(() => this.windowService.close()),
    ), 
    { dispatch: false }
  );

  openWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WindowActions.openWindow),
      map((action) => action.windowParams),
      tap(windowParams => this.windowService.open(windowParams)),
    ), 
    { dispatch: false }
  );

  closeWindowAndOpenNext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WindowActions.closeWindowAndOpenNext),
      map((action) => action.windowParams),
      tap(windowParams => this.windowService.close()),
      map(windowParams => WindowActions.openWindow({ windowParams })),
    )
  );

  constructor(
    private actions$: Actions,
    private windowService: CustomWindowService,
  ) {}
}
